<template>
    <div class="download-app-menu h-align">
        <div class="title h-align">
            <img src="@/assets/img/landingPage/aboutUs/find_house_app.png"/>
            下載飛豬找房App
        </div>
        <button class="download" @click="mobileRedirect">下載</button>
    </div>
</template>
<script>
import constant from '@/constant'
import { mapGetters } from 'vuex'

export default {
    created(){
        this.$store.dispatch('getDeviceSystem')
    },
    methods: {
        mobileRedirect: function () {
            let _self =this

            if(_self.system == 'pc'){
                return true
            }else{
                document.location = constant.fetuzbookTenantSchema+'://?houseCid='+_self.houseId+''
                var time = (new Date()).getTime();
                setTimeout(function(){
                    setTimeout(function(){ // <-- start new thread after activation
                        var now = (new Date()).getTime();
                        if((now - time)<400) {
                            if(confirm('你未安裝飛豬找房，將引導AppStore')){
                                window.open(_self.appUrl.tenant)
                            }
                        }
                    }, 10); // <-- start new thread after activation
                }, 300);
            }
        },
    },
    computed: {
        ...mapGetters({
            system: 'GET_DEVICE_SYSTEM',
            appUrl: 'GET_APP_URL',
            houseId: 'GET_SHARE_HOUSE_ID',
        })
    },
}
</script>
<style lang="scss" scoped>
.download-app-menu{
    position: fixed;
    padding: 7px 11px;
    justify-content: space-between;
    z-index: 6;
    background: #fff;
    width: 100%;
    .title{
        font-size: 16px;
        >img{
            width: 38px;
            margin-right: 13px;
        }
    }
    .download{
        width: 68px;
        border-radius: 4px;
        border: solid 1px #2db2ff;
        color: #2db2ff;
        font-size: 16px;
        background: #fff;
        height: 30px;
        box-sizing: border-box;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/shareHouse/downloadAppMenu.vue